var React = require('react');

function IconB3Burger (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fill":"#A1BF36","cx":"15.999","cy":"16","r":"15.999","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"M10.777,11.169h10.447c0.282,0,0.509-0.227,0.509-0.51c0-0.281-0.227-0.509-0.509-0.509H10.777\n\t\tc-0.282,0-0.509,0.228-0.509,0.509C10.268,10.942,10.495,11.169,10.777,11.169z M21.223,15.331H10.777\n\t\tc-0.282,0-0.509,0.229-0.509,0.51c0,0.283,0.227,0.511,0.509,0.511h10.447c0.282,0,0.509-0.228,0.509-0.511\n\t\tC21.732,15.56,21.505,15.331,21.223,15.331z M21.223,20.83H10.777c-0.282,0-0.509,0.228-0.509,0.51c0,0.283,0.227,0.51,0.509,0.51\n\t\th10.447c0.282,0,0.509-0.227,0.509-0.51C21.732,21.058,21.505,20.83,21.223,20.83z","key":1})]));
}

IconB3Burger.displayName = "IconB3Burger";

IconB3Burger.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = IconB3Burger;

IconB3Burger.default = IconB3Burger;
